import { print } from 'graphql';
import { gql } from 'graphql-tag';

import { sentryCaptureException } from '../../utilities/sentryCaptureException';
import { defaultDoc } from '../share/defaultDoc';
import type { PreviousTaskComments } from './previousTaskComments.types';

export const previousTaskCommentsPullQueryBuilder = (document: PreviousTaskComments) => {
  let doc = document;
  if (!doc) {
    (doc as unknown) = {
      ...defaultDoc,
      dateModified: '1900-01-01T01:01:01.1234567-06:00',
    };
  }

  const query = print(gql`
    query mobileTaskWiseAuditComments($lastRequested: DateTime!) {
      mobileTaskWiseAuditComments(lastRequested: $lastRequested) {
        pkTaskWiseAuditComments
        fkAssetInspectionTask
        inspectorId
        fkClerk
        inspectorRoleId
        comment
        dateCreated
        dateModified
        createdBy
        pkUuid
        isActive
        attentionFlag
      }
    }
  `);

  return {
    query,
    variables: {
      lastRequested: doc?.dateModified ? doc?.dateModified : doc?.dateCreated,
    },
  };
};

export const previousTaskCommentsPullModifier = (doc: PreviousTaskComments) => {
  const result = {
    ...doc,
  };
  try {
    if (result.dateModified !== null) {
      const dateCreated = new Date(result.dateCreated);
      const dateModified = new Date(result.dateModified);
      if (dateCreated > dateModified) {
        {
          result.dateModified = result.dateCreated;
        }
      }
    } else {
      result.dateModified = result.dateCreated;
    }
    if (result.fkClerk) {
      result.clerkId = result.fkClerk;
    }
  } catch (error) {
    console.log('Error previous comments pull modifier ', error); // eslint-disable-line no-console
    // console logs will be removed once sentry implementation is done
    sentryCaptureException(
      error,
      '~ file: queryBuilder.tsx ~ line 95 ~ previousTaskCommentsPullModifier ~',
    );
  }
  return result;
};
